var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wl-circular-timer"},[_c('canvas',{ref:"counter",attrs:{"height":_vm.dimensions,"width":_vm.dimensions}})])}
var staticRenderFns = []

export { render, staticRenderFns }